import { Box, Grid } from '@mui/material';
import { Modal } from '@shared/components/modals/Modal';

interface IFlexCertificateModalProps {
  open: boolean;
  handleClose: () => void;
  html: string;
  isOFCUOL: boolean;
}

export const FlexCertificateModal = ({ open, handleClose, html, isOFCUOL }: IFlexCertificateModalProps) =>
(
  <Modal
    open={open}
    title={isOFCUOL ? 'Flex Certificate' : 'Data mismatch'}
    dialogWidth={isOFCUOL ? '1000px' : '550px'}
    onClose={handleClose}
  >
    <Grid container>
      <Grid item md={12} padding={2}>
        <Box dangerouslySetInnerHTML={{ __html: html }} />
      </Grid>
    </Grid>
  </Modal>
);

